"use strict";

/*
* ***********************************Example of Usage***********************************
*
* 1 - Simple usage
*    <Separator />
*
* 2 - When width is defined
*    <Separator width="150px" />
*
*/

const Separator = (props) => {
  var width = props.width || "auto";
  return (
    <div className="mt-15 mb-15 u-bb-dots u-clear" style={{width: width}}></div>
  );
};

Separator.propTypes = {
  width: React.PropTypes.string
};

module.exports = Separator;



// WEBPACK FOOTER //
// ./app/shared/components/Separator/separator.jsx